import { Control210 } from "aic";

/**
 * Props for the AnnotationNotesField component.
 */
interface AnnotationNotesFieldProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

/**
 * Textarea for entering additional notes for an annotation.
 *
 * @param props - Destructured parameter object
 * @param props.value - Current text value
 * @param props.onChange - Change handler
 * @param props.disabled - Optional disabled flag
 */
export const AnnotationNotesField = ({
  value,
  onChange,
  disabled = false,
}: AnnotationNotesFieldProps): React.ReactElement => {
  return (
    <Control210
      id="notes-textarea"
      label="Additional notes"
      labelWidth="auto"
      maxWidthCols={12}
      value={value}
      setValue={onChange}
      type="textarea"
      rows={2}
      placeholder="Enter any additional notes or context for this annotation..."
      disabled={disabled}
    />
  );
};

AnnotationNotesField.displayName = "AnnotationNotesField";
